import { dateTFormat } from "../utility/Utility";
import { createSlice } from "@reduxjs/toolkit";

export interface DeliveryOrder {
    id: string;
    orderReference: string;
    orderCreatedBy: string;
    displayName: string;
    createdDate: string;
    orderStatus:
    | "Pending"
    | "AcceptedByCart"
    | "ApprovedByRestaurant"
    | "Preparing"
    | "ReadyAtKitchen"
    | "IssuedByKitchen"
    | "ArrivedAtCart"
    | "Completed"
    | "Cancelled"
    | "Tentative";
    deliveryStatus:
    | "Pending"
    | "PackingComplete"
    | "Dispatched"
    | "OutForDelivery"
    | "Delivered";
    selected: boolean;
    address: string;
    cart?: any;
    customer?: any;
    isDirectRestaurantOrder: boolean;
    orderItems: any;
    paymentMethod: string;
    totalPrice: number;
    createdAt?: {
        _seconds: number;
        _nanoseconds: number;
    };
    deliverAt?: {
        _seconds: number;
        _nanoseconds: number;
    };
    walletPaymentAmount?: any;
    paymentCompleted?: boolean;
    isScheduledOrder?: boolean;
    paymentSummary?: {
        totalPrice: number;
        netAmount: number;
        cartCommission: number;
        cardPaymentAmount: number;
        cashPaymentAmount: number;
        walletPaymentAmount: number;
    };
    restaurantId?: string;
}

export interface AssignCartToOrderRequest {
    orders: Array<{
        orderId: string;
        cartId: string;
    }>;
}


export interface GetDeliveryOrderListParam {
    startDate: string;
    orderStatus: string;
    restaurantId: string;
    rowsPerPage: number;
    orderCreatedBy: string;
    cartName: string;
    showOnlyUnassigned: boolean;
}

const initialState = {
    selectedDeliveryOrder: null,
    orderStatus: "All",
    orderDate: dateTFormat(new Date()),
    orderEndDate: dateTFormat(new Date()),
    rowsPerPage: 10,
    orderCreatedBy: "All",
    cartName: "",
    showOnlyUnassigned: false,
    selectedActionType: {
        value: "",
        label: "Select action type"
    },
    deliveryStatus: "All",
    agentSourceFilter: {
        value: "all",
        label: "All",
        type: "all"
    },
    deliveryCartId: "",
    organizationId: "",
};

export const deliveryOrderSlice = createSlice({
    name: "deliveryOrder",
    initialState,
    reducers: {
        setSelectedDeliveryOrder: (state, action) => {
            state.selectedDeliveryOrder = action.payload;
        },
        clearSelectedDeliveryOrder: (state) => {
            state.selectedDeliveryOrder = null;
        },
        setDeliveryOrderCreatedBy: (state, action) => {
            state.orderCreatedBy = action.payload;
        },
        clearDeliveryOrderCreatedBy: (state) => {
            state.orderCreatedBy = "All";
        },
        setDeliveryCartName: (state, action) => {
            state.cartName = action.payload;
        },
        clearDeliveryCartName: (state) => {
            state.cartName = "";
        },
        setDeliveryOrderStatus: (state, action) => {
            state.orderStatus = action.payload;
        },
        clearDeliveryOrderStatus: (state) => {
            state.orderStatus = "All";
        },
        setDeliveryStatus: (state, action) => {
            state.deliveryStatus = action.payload;
        },
        clearDeliveryStatus: (state) => {
            state.deliveryStatus = "All";
        },
        setDeliveryAgentSourceFilter: (state, action) => {
            state.agentSourceFilter = action.payload;
        },
        clearDeliveryAgentSourceFilter: (state) => {
            state.agentSourceFilter = {
                value: "all",
                label: "All",
                type: "all"
            };
        },

        setDeliveryCartFilterId: (state, action) => {
            state.deliveryCartId = action.payload;
        },
        clearDeliveryCartFilterId: (state) => {
            state.deliveryCartId = "";
        },
        setOrganizationFilterId: (state, action) => {
            state.organizationId = action.payload;
        },
        clearOrganizationFilterId: (state) => {
            state.organizationId = "";
        },
        setDeliveryOrderDate: (state, action) => {
            state.orderDate = action.payload;
        },
        setDeliveryOrderEndDate: (state, action) => {
            state.orderEndDate = action.payload;
        },
        clearDeliveryOrderDate: (state) => {
            state.orderDate = dateTFormat(new Date());
        },
        clearDeliveryOrderEndDate: (state) => {
            state.orderEndDate = dateTFormat(new Date());
        },
        setDeliveryRowsPerPage: (state, action) => {
            state.rowsPerPage = action.payload;
        },
        clearDeliveryRowsPerPage: (state) => {
            state.rowsPerPage = 10;
        },
        setShowOnlyUnassigned: (state, action) => {
            state.showOnlyUnassigned = action.payload;
        },
        clearShowOnlyUnassigned: (state) => {
            state.showOnlyUnassigned = false;
        },
        setDeliveryActionType: (state, action) => {
            state.selectedActionType = action.payload;
        },
        clearDeliveryActionType: (state) => {
            state.selectedActionType = {
                value: "",
                label: "Select action type"
            };
        },
    },
});

export const {
    setSelectedDeliveryOrder,
    clearSelectedDeliveryOrder,
    setDeliveryOrderCreatedBy,
    clearDeliveryOrderCreatedBy,
    setDeliveryCartName,
    clearDeliveryCartName,
    setDeliveryOrderStatus,
    clearDeliveryOrderStatus,
    setDeliveryOrderDate,
    setDeliveryOrderEndDate,
    clearDeliveryOrderDate,
    clearDeliveryOrderEndDate,
    setDeliveryRowsPerPage,
    clearDeliveryRowsPerPage,
    setShowOnlyUnassigned,
    clearShowOnlyUnassigned,
    setDeliveryActionType,
    clearDeliveryActionType,
    setDeliveryStatus,
    clearDeliveryStatus,
    setDeliveryAgentSourceFilter,
    clearDeliveryAgentSourceFilter,
    setDeliveryCartFilterId,
    clearDeliveryCartFilterId,
    setOrganizationFilterId,
    clearOrganizationFilterId,
} = deliveryOrderSlice.actions;

export default deliveryOrderSlice.reducer;